var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"menu"},[_c('div',{staticClass:"logo"},[_c('img',{staticClass:"logoImg",attrs:{"src":_vm.icon,"alt":""}}),_c('h2',[_vm._v(_vm._s(_vm.titleText))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }